import { Flex, Spacer, Text } from '@chakra-ui/react'
import React from 'react'
import { CircleBadge } from '~/components/shared/CircleBadge'
import { CircleBadgeVariant } from '~/components/shared/componentStyles/CircleBadge.style'
import { ReferButton } from '~/pages/WebPhone/ReferButton'
import { PresenceState } from '~/utils/xml'

import {
  ParkTargetVariants,
  useParkTargetStyle,
} from './componentStyles/ParkTarget.style'

interface ParkTargetProps {
  parkName: string
  parkExtension: string
  presence: PresenceState
  onPark: (parkExtension: string) => void
}
export const ParkTarget = ({
  parkName,
  parkExtension,
  presence,
  onPark,
}: ParkTargetProps) => {
  const handleClick = () => {
    if (presence === PresenceState.Unavailable) return
    onPark(parkExtension)
  }

  let variant: ParkTargetVariants
  let presenceVariant: CircleBadgeVariant
  switch (presence) {
    case PresenceState.Available:
      variant = ParkTargetVariants.Available
      presenceVariant = CircleBadgeVariant.Green
      break
    case PresenceState.Unavailable:
      variant = ParkTargetVariants.Unavailable
      presenceVariant = CircleBadgeVariant.Red
      break
    default:
      variant = ParkTargetVariants.Default
      presenceVariant = CircleBadgeVariant.Gray
      break
  }

  const styles = useParkTargetStyle({ variant })

  return (
    <Flex sx={styles.container}>
      <CircleBadge variant={presenceVariant} />
      <Text sx={styles.text}>{parkName}</Text>
      <Spacer />
      <ReferButton
        sx={styles.button}
        buttonText="Park Call"
        onClick={handleClick}
      />
    </Flex>
  )
}
